import { useMemo } from 'react';
import useMobile from '../../hooks/useMobile';

export function Pagination({
  pageActive = 1,
  totalCount = 1,
  onPageChange,
  mobileVisibleCount = 5,
  desktopVisibleCount = 10,
}) {
  const { isMobile } = useMobile();

  const totalPages = Math.max(1, Number(totalCount) || 1);
  const currentPage = Math.min(Math.max(1, Number(pageActive) || 1), totalPages);
  const visibleCount = isMobile ? mobileVisibleCount : desktopVisibleCount;

  const { startPage, endPage } = useMemo(() => {
    const groupIndex = Math.floor((currentPage - 1) / visibleCount);
    const start = groupIndex * visibleCount + 1;
    const end = Math.min(start + visibleCount - 1, totalPages);

    return { startPage: start, endPage: end };
  }, [currentPage, totalPages, visibleCount]);

  const pageNumbers = useMemo(
    () => Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index),
    [startPage, endPage]
  );

  const isFirstPage = currentPage <= 1;
  const isLastPage = currentPage >= totalPages;

  const movePage = (page) => {
    if (!onPageChange) return;

    const targetPage = Math.min(Math.max(1, page), totalPages);
    if (targetPage === currentPage) return;
    onPageChange(targetPage);
  };

  return (
    <div className="c-pagination" role="navigation" aria-label="페이지네이션">
      {!isMobile && (
        <button type="button" className="ir i-page-first" onClick={() => movePage(1)} disabled={isFirstPage}>
          첫페이지
        </button>
      )}
      <button type="button" className="ir i-page-prev" onClick={() => movePage(currentPage - 1)} disabled={isFirstPage}>
        이전페이지
      </button>

      <span className="number">
        {pageNumbers.map((pageNumber) => (
          <button
            key={pageNumber}
            type="button"
            className={pageNumber === currentPage ? 'active' : ''}
            onClick={() => movePage(pageNumber)}
            disabled={pageNumber === currentPage}
            aria-current={pageNumber === currentPage ? 'page' : undefined}
          >
            {pageNumber}
          </button>
        ))}
      </span>

      <button type="button" className="ir i-page-next" onClick={() => movePage(currentPage + 1)} disabled={isLastPage}>
        다음페이지
      </button>
      {!isMobile && (
        <button type="button" className="ir i-page-last" onClick={() => movePage(totalPages)} disabled={isLastPage}>
          마지막페이지
        </button>
      )}
    </div>
  );
}
